import {
  COLUMNS_CONFIG,
  DEFAULT_COLUMNS,
  FIELDS,
  SUBSCRIPTIONS,
} from 'frontend/client-communication-messages/client-communication-messages-table-helpers'
import { IDataModelTypeConfig } from 'frontend/dataModels/types/IDataModelTypeConfig'

export const ClientCommunicationMessageDataModelTypeConfig: IDataModelTypeConfig = {
  fields: FIELDS,
  subscriptions: SUBSCRIPTIONS,
  defaultColumns: DEFAULT_COLUMNS,
  columnConfig: COLUMNS_CONFIG,
}
